import Login from "@/views/login/login";
import Dashboard from "@/views/dashboard";
export default [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta:{
      title:'主控台'
    }
  },
  {
    path: '/editpwd',
    name: 'Editpwd',
    component: () => import('../views/login/editpwd.vue'),
    meta:{
      title:'修改密码'
    }
  }
]
